import Vuex from "vuex"
import Vue from "vue"

Vue.use(Vuex)

export default new Vuex.Store({
  modules: {
    user: {
      namespaced: true,
      state: {
        user: {}
      },
      mutations: {
        add_user(state, user){
          state.user = user;
        },
        log_out(state){
          state.user = {};
        }
      }
    },

    blog: {
      namespaced: true,
      state: {
        blog: []
      },
      mutations: {
        add(state, data){
          state.blog.push(data)
        },
        clear(state){
          state.blog = []
        }
      }
    },

    categories: {
      namespaced: true,
      state: {
        categories: []
      },
      mutations: {
        add(state, data){
          state.categories.push(data)
        },
        clear(state){
          state.categories = []
        }
      }
    },

    projects: {
      namespaced: true,
      state: {
        projects: []
      },
      mutations: {
        add(state, data){
          state.projects.push(data)
        },
        clear(state){
          state.projects = []
        }
      }
    },

    similar: {
      namespaced: true,
      state: {
        similar: []
      },
      mutations: {
        add(state, data){
          state.similar.push(data)
        },
        clear(state){
          state.similar = []
        }
      }
    },

  }
})



// WEBPACK FOOTER //
// ./src/store.js